/**
 * Phase 6 cross-cutting PR 3 — `<DiagContextHint>`.
 *
 * Trust-signal panel under the severity row that surfaces the
 * 5-key safe subset of `athleteContext` transmitted with the bug
 * report. Per direction.md §2 PRESENTATION row + OVERRIDES.md D1.
 *
 * Tells the user what's about to be sent BEFORE they hit submit,
 * preventing the "what did this just upload?" surprise that
 * vanilla's silent full-context transmission could cause.
 */

import { BUG_REPORT_SAFE_ATHLETE_CONTEXT_KEYS } from '../../lib/buildBugPayload';
import { Icon } from '../icons/registry';
import { useIconSystem } from '../../hooks/useIconSystem';
import styles from './DiagContextHint.module.css';

export function DiagContextHint(): JSX.Element {
  const iconsOn = useIconSystem();
  return (
    <div className={styles.hint} role="note">
      {/* CD-ICONS-01 — `sys.info` @16 ("empty-state hints"; this is a
          `role="note"` hint, the same register). */}
      <span className={styles.icon} aria-hidden="true">
        {iconsOn ? <Icon name="sys.info" size={16} /> : 'ⓘ'}
      </span>
      <div className={styles.body}>
        <span className={styles.line}>
          Includes: current page, browser, screen size, and your journey type.
        </span>
        <span className={styles.detail}>
          Diagnostic context fields:{' '}
          {BUG_REPORT_SAFE_ATHLETE_CONTEXT_KEYS.map((key, idx) => (
            <span key={key}>
              <code className={styles.key}>{key}</code>
              {idx < BUG_REPORT_SAFE_ATHLETE_CONTEXT_KEYS.length - 1 ? ' · ' : ''}
            </span>
          ))}
        </span>
      </div>
    </div>
  );
}
